import { Typography } from '@mui/material';

export const DriverLabel = ({ label }: { label: string }) => {
  if (label === 'Minimum deposit') {
    return (
      <>
        <Typography
          sx={{
            color: 'neutral.darker',
            fontWeight: 500,
            fontSize: { xs: 13, sm: 16 },
            whiteSpace: 'nowrap',
            display: { xs: 'none', md: 'block' },
          }}
        >
          Minimum deposit
        </Typography>
        <Typography
          sx={{
            color: 'neutral.darker',
            fontWeight: 500,
            fontSize: { xs: 13, sm: 16 },
            whiteSpace: 'nowrap',
            display: { xs: 'block', md: 'none' },
          }}
        >
          Min. deposit
        </Typography>
      </>
    );
  }

  return (
    <Typography
      sx={{
        color: 'neutral.darker',
        fontWeight: 500,
        fontSize: { xs: 13, sm: 16 },
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </Typography>
  );
};
